export enum TextLogycaType {
  NAV_BAR_SERCTION = "NAV_BAR_SERCTION",
  NAV_BAR_MENU = "NAV_BAR_MENU",
  LIST_TITTLE = "LIST_TITTLE",
  LIST_DESCRIPTION = "LIST_DESCRIPTION",
  CARD_TITTLE = "CARD_TITTLE",
  CARD_DESCRIPTION = "CARD_DESCRIPTION",
}

export interface TextLogycaProps {
  type?: TextLogycaType;
  children?: React.ReactNode;
}
